/* eslint-disable react/prop-types */
import React, { Fragment } from "react"
import styles from "./styles"
import {
  Typography,
  Button,
  IconButton,
  Tooltip,
  Hidden,
  Menu,
  MenuItem,
} from "@material-ui/core"
import withStyles from "@material-ui/core/styles/withStyles"
import update from "immutability-helper"
import SortButton from "./SortButton"
import CloseIcon from "@material-ui/icons/Close"
import SortIcon from "@material-ui/icons/UnfoldMore"
import { isEmpty } from "lodash"

class SortControls extends React.Component {
  state = {
    activeSort: [],
    showMobileSort: null,
  }
  handleSortClicked = (value) => {
    this.setState(
      update(this.state, {
        activeSort: {
          $set: [
            value,
            this.state.activeSort[0] === value &&
            this.state.activeSort[1] === "DESC"
              ? "ASC"
              : "DESC",
          ],
        },
      }),
    )
    this.callOnSort()
  }
  handleClearSort = () => {
    if (this.state.activeSort.length > 0) {
      this.setState(
        update(this.state, {
          activeSort: {
            $set: [],
          },
          showMobileSort: {
            $set: null,
          },
        }),
      )
      this.callOnSort()
    }
  }
  callOnSort = () => {
    setTimeout(() => {
      this.props.onSort?.(this.state.activeSort)
    }, 40)
  }

  handleShowMobileSort = (e) => {
    this.setState({
      showMobileSort: e.currentTarget,
    })
  }

  handleMobileSortClose = () => {
    this.setState({
      showMobileSort: null,
    })
  }

  render() {
    const { classes, controls = [], options = {} } = this.props
    return (
      <Fragment>
        <Hidden smDown>
          <div className={classes.sortControls}>
            <div className={classes.text}>
              {!isEmpty(this.state.activeSort) && (
                <Tooltip title="Clear Sort">
                  <IconButton size="small" onClick={this.handleClearSort}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              )}
              {options?.hideLabel !== true && (
                <Typography
                  variant="subtitle2"
                  className={classes.sortControlsTypography}
                >
                  Sort By:
                </Typography>
              )}
            </div>
            {controls.map((control) => (
              <SortButton
                activeSort={this.state.activeSort}
                key={control.value}
                control={control}
                onClick={this.handleSortClicked}
                props={options.SortButtonProps}
              />
            ))}
          </div>
        </Hidden>
        <Hidden mdUp>
          <Fragment>
            <IconButton onClick={this.handleShowMobileSort}>
              <SortIcon />
            </IconButton>
            <Menu
              getContentAnchorEl={null}
              open={this.state.showMobileSort !== null}
              anchorEl={this.state.showMobileSort}
              onClose={this.handleMobileSortClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              classes={{
                paper: classes.mobileSortPopover,
              }}
            >
              <MenuItem onClick={this.handleClearSort}>
                {!isEmpty(this.state.activeSort) && (
                  <CloseIcon style={{ fontSize: 18, marginLeft: -4 }} />
                )}
                <Typography
                  variant="subtitle2"
                  className={classes.sortControlsTypography}
                >
                  Sort By:
                </Typography>
              </MenuItem>
              {controls.map((control) => (
                <SortButton
                  isMenuItem
                  activeSort={this.state.activeSort}
                  key={control.value}
                  control={control}
                  onClick={this.handleSortClicked}
                />
              ))}
            </Menu>
          </Fragment>
        </Hidden>
      </Fragment>
    )
  }
}

export default withStyles(styles, { withTheme: true, name: "CAT" })(
  SortControls,
)
